import { Tooltip as AntTooltip } from 'antd';
import React, { CSSProperties, FC } from 'react';
import { twMerge } from '@shared/utils/twMerge';

type TooltipProps = {
  label: string | undefined;
  className?: string;
  MAX_LABEL_LENGTH?: number;
  overlayInnerStyle?: CSSProperties;
};

export const CustomTooltip: FC<TooltipProps> = ({
  label = '',
  MAX_LABEL_LENGTH = 0,
  className,
  overlayInnerStyle,
}) => {
  const truncatedLabel =
    label?.length > MAX_LABEL_LENGTH ? `${label.substring(0, MAX_LABEL_LENGTH)}...` : label;

  const tooltipInnerStyle = overlayInnerStyle ?? { width: 'max-content' };

  return (
    <AntTooltip
      color="white"
      overlayInnerStyle={tooltipInnerStyle}
      title={
        label?.length > MAX_LABEL_LENGTH ? (
          <span className={'text-1424 flex items-center pt-[0.125rem] text-black'}>{label}</span>
        ) : undefined
      }
    >
      <span
        className={twMerge(
          'flex h-[2.5rem] max-w-full items-center truncate pt-[0.125rem]',
          className
        )}
      >
        {MAX_LABEL_LENGTH ? truncatedLabel : label}
      </span>
    </AntTooltip>
  );
};
